//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FlowSteps from '@/components/common_flowSteps.vue'
import InputList from '@/components/input_item'
import MyForm from '@/components/common_form'
import PageBtns from '@/components/common_pageBtns'
export default {
  name: '',
  components: { FlowSteps, InputList, MyForm, PageBtns },
  data () {
    return {
      isPickerShow: false,
      pickerList: ['朵拉', '朵拉小羊'],
      formConfig1: {
        fontSize: '14px',
        list:[
          { type: 'input', title: "事业部", value: "朵拉事业部", no_arrow: true, read: true },
          { type: 'input', title: "产品品牌", value: "朵拉",  read: true, action: () => this.isPickerShow=true },
          { type: 'input', title: "当前门店", value: "[S20023126]铜川新起点奶粉", no_arrow: true, read: true },
        ]
      },
      formConfig2: {
        fontSize: '14px',
        list:[
          { 
            type: 'phone', title: "手机号码", placeholder:'输入会员手机号码', value: "", 
            no_arrow: true, btn: {text:'查询', action:() => {}}
          },
          { type: 'input', title: "会员编号", value: "朵拉", no_arrow: true,  read: true },
          { type: 'input', title: "所属门店", value: "朵拉", no_arrow: true,  read: true },
          { type: 'input', title: "积分余量", value: "[S20023126]铜川新起点奶粉", no_arrow: true, read: true },
        ]
      },
      flowConfig: {
        bg: '#fff',
        padding: '15px 40px',
        size: '30px',
        numberSize: '18px',
        textSize: '14px',
        textTop: '33px',
        lineWidth: '3px',
        list: [
          {number:1, text:'验证身份', isDone:true},
          {number:2, text:'录入单品码', isDone:false},
          {number:3, text:'提交单据', isDone:false},
          {number:4, text:'积分到账', isDone:false},
        ]
      },
      btnConfig: {
        list: [ {text:'返回', type: 'primary', action: () => this.$router.go(-1) } ],
      },
    }
  },
  props: [],
  computed: {},
  created () {},
  methods: {
    onPickerConfirm (value) {
      this.formConfig.list[1].value = value
      this.isPickerShow=false
    }
  }
}
